import gameIds from 'a/hub/data/GameIds';

// replace "NEW_GAME" with your gameId
export const GAME_ID = gameIds.GRUMPY_GOBLINS;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  HOME: 'HOME',
  LOADING: 'LOADING',
  INSTRUCTION: 'INSTRUCTION',
  PRACTICE: 'PRACTICE',
  ONBOARDING: 'ONBOARDING',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
};

// reference for the number of questions in a level
// to be kept consistent through the game
export const QUESTIONS_PER_LEVEL = 12;

// reference for calculating mastery
export const MASTERY_PERCENTAGE = 0.8;

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  SAVE_SCREEN_COORDINATES: 'SAVE_SCREEN_COORDINATES',
};

// a collection of frame references for goblin animation
export const FRAMES = {
  idle: [28, 89],
  spit: [90, 119],
  eating: [120, 179],
  talking: [0, 27],
  wrongTransition: [180, 199],
  hangry: [200, 218],
};

export const ROUND_STATUSES = {
  ROUND_STARTED: 'ROUND_STARTED',
  ROUND_COMPLETED: 'ROUND_COMPLETED',
  ROUND_INTERRUPTED: 'ROUND_INTERRUPTED',
};
